export const addSignUpTrackingScript = (memberId: string) => {
  const mainScriptElement = document.getElementById('hpt-main-script');

  if (mainScriptElement && mainScriptElement.parentNode) {
    const scriptElement = document.createElement('script');
    scriptElement.type = 'text/javascript';
    scriptElement.text = `
      var hpt_trace_info = {
        '_mode': 'join',
        '_memid': '${memberId}'
      };
    `;

    mainScriptElement.parentNode.insertBefore(scriptElement, mainScriptElement);
  }
};

export const addConfirmReservationTrackingScript = (
  email: string,
  amount: number,
) => {
  const mainScriptElement = document.getElementById('hpt-main-script');

  if (mainScriptElement && mainScriptElement.parentNode) {
    const scriptElement = document.createElement('script');
    scriptElement.type = 'text/javascript';
    scriptElement.text = `
      var hpt_trace_info = {
        '_mode': 'order',
        '_memid': '${email}',
        '_total_price': '${amount}'
      };
    `;

    mainScriptElement.parentNode.insertBefore(scriptElement, mainScriptElement);
  }
};
